
export function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiry = payload.exp * 1000;
    return Date.now() > expiry;
  } catch (e) {
    return true;
  }
}


export function getAuth() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if (!token || isTokenExpired(token)) {
    localStorage.clear();
    return { token: null, role: null };
  }

  return { token, role };
}

export function setAuth(token,username, role) {
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
 // localStorage.setItem("username", username);
}


export function hasAnyRole(roles = []) {
  const userRole = localStorage.getItem("role");
  if (!userRole) return false;
  return roles.includes(userRole);
}

export function logout() {
  localStorage.clear();
  window.location.href = '/';
}
